import { render, staticRenderFns } from "./CreditScoringEksternal.vue?vue&type=template&id=06fccdf2&scoped=true&"
import script from "./CreditScoringEksternal.vue?vue&type=script&lang=js&"
export * from "./CreditScoringEksternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fccdf2",
  null
  
)

export default component.exports